(() => {
  let refreshTimer;
  let activeRequest;

  document.addEventListener('change', (event) => {
    const sizeInput = event.target.closest(
      '.filter--menu-size-grid .filter--input[type="checkbox"]'
    );

    if (!sizeInput) return;

    clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      refreshFilterCounts(sizeInput);
    }, 100);
  });

  async function refreshFilterCounts(changedInput) {
    const filterRoot = changedInput.closest('.filter--root');
    const filterForm = filterRoot?.querySelector('.filter--form');

    if (!filterForm) {
      console.warn('Filter form not found.');
      return;
    }

    const url = buildFilteredUrl(filterForm);

    if (activeRequest) {
      activeRequest.abort();
    }

    activeRequest = new AbortController();

    filterRoot.classList.add('filter--counts-loading');

    try {
      const response = await fetch(url.toString(), {
        signal: activeRequest.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Filter request failed: ${response.status}`);
      }

      const html = await response.text();
      const documentFromResponse = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      updateBrandCounts(filterRoot, documentFromResponse);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Unable to refresh filter counts:', error);
      }
    } finally {
      filterRoot.classList.remove('filter--counts-loading');
    }
  }

  function buildFilteredUrl(form) {
    const url = new URL(window.location.href);

    /*
     * Remove existing Shopify filter parameters so the URL reflects
     * the current state of the open filter form.
     */
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (
        key.startsWith('filter.') ||
        key === 'sort_by' ||
        key === 'page'
      ) {
        url.searchParams.delete(key);
      }
    });

    const formData = new FormData(form);

    for (const [name, value] of formData.entries()) {
      if (!name || value === '') continue;

      /*
       * "browse" contains a collection URL and is not a Shopify
       * storefront-filter query parameter.
       */
      if (name === 'browse') continue;

      url.searchParams.append(name, value);
    }

    return url;
  }

  function updateBrandCounts(currentFilterRoot, responseDocument) {
    const currentBrandInputs = currentFilterRoot.querySelectorAll(
      'input[name*="vendor"]'
    );

    currentBrandInputs.forEach((currentInput) => {
      const matchingInput = findMatchingInput(
        responseDocument,
        currentInput.name,
        currentInput.value
      );

      if (!matchingInput) return;

      const newCount = matchingInput
        .closest('.filter--link')
        ?.querySelector('.filter--value-count')
        ?.textContent
        ?.trim();

      const currentCount = currentInput
        .closest('.filter--link')
        ?.querySelector('.filter--value-count');

      if (currentCount && newCount !== undefined) {
        currentCount.textContent = newCount;
      }
    });
  }

  function findMatchingInput(documentRoot, name, value) {
    const candidates = documentRoot.querySelectorAll(
      'input[name*="vendor"]'
    );

    return Array.from(candidates).find((input) => {
      return input.name === name && input.value === value;
    });
  }
})();